import React from 'react';

export default function Problem() {
    return (
        <section className="py-16 px-4 bg-white">
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-black">
                    Por que muitas PMEs não crescem?
                </h2>
                <p className="text-lg text-gray-700 mb-8">
                    Agências grandes cobram caro, demoram para responder e não entendem suas necessidades reais. Você merece um parceiro que seja <span className="font-bold text-cyan-500">rápido, personalizado e acessível</span>.
                </p>
                <div className="grid md:grid-cols-3 gap-6">
                    <div className="bg-cyan-50 p-6 rounded-lg border-2 border-cyan-400">
                        <div className="text-3xl mb-3">⚡</div>
                        <h3 className="font-bold text-lg mb-2">Rápido</h3>
                        <p>Respostas em horas, não dias</p>
                    </div>
                    <div className="bg-green-50 p-6 rounded-lg border-2 border-green-500">
                        <div className="text-3xl mb-3">🎯</div>
                        <h3 className="font-bold text-lg mb-2">Personalizado</h3>
                        <p>Focado nas suas necessidades reais</p>
                    </div>
                    <div className="bg-purple-50 p-6 rounded-lg border-2 border-purple-500">
                        <div className="text-3xl mb-3">💰</div>
                        <h3 className="font-bold text-lg mb-2">Acessível</h3>
                        <p>Preços justos para PMEs</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
